<mat-dialog-content class="mat-body">
  This invitation is no longer active.
</mat-dialog-content>
